import React, { useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { useNavigate } from 'react-router-dom';

import { Box, Stepper, Step, StepLabel, Typography, Button } from '@mui/material';
import TechStepFirstContainer from './TechStepFirstContainer';
import { setProject } from '../../../modules/techModule/project';

import * as chanceApi from '../../../lib/api/chance';

//수주,착수보고/분석설계/구축(이행)/완료(검수)
const steps = [
  { value: 0, label: '제안영업', color: 'info' },
  { value: 1, label: '착수보고', color: 'error' },
  { value: 2, label: '분석설계', color: 'success' },
  { value: 3, label: '구축(이행)', color: 'secondary' },
  { value: 4, label: '완료(검수)', color: 'warning' },
];

const TechStepperContainer = ({
  activeStep,
  activeTap,
  handleTabChange,
  handleGoBack,
}) => {

  const stepperRef = useRef();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();


  const { project } = useSelector(({ techModule }) => ({
    project: techModule.project.project,
  }));

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };


  const handleNext = () => {
    let dataToSubmit = {
      prjUuid: project.prjUuid,
    };


    if (Number(project.techGrade) === 0) {
      dataToSubmit.techGrade = 1;
      dataToSubmit.techStatus = '착수보고';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 1) {
      dataToSubmit.techGrade = 2;
      dataToSubmit.techStatus = '분석설계';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 2) {
      dataToSubmit.techGrade = 3;
      dataToSubmit.techStatus = '구축(이행)';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 3) {
      dataToSubmit.techGrade = 4;
      dataToSubmit.techStatus = '완료(검수)';
      updateProjectStatus(dataToSubmit);
    }
  };

  const updateProjectStatus = async (dataToSubmit) => {
    try {
      // console.log(dataToSubmit,'dataToSubmit');
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        //console.log(res.data.info, 'tech Project');
        dispatch(setProject(res.data.info));
        navigate(
          `/techmng/${dataToSubmit.prjUuid}/${dataToSubmit.techGrade}/1`,
        );
        enqueueSnackbar(`[${dataToSubmit.techStatus}] 상태 변경 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  //이전단계로 이동
  const handleBack = () => {
    let dataToSubmit = {
      prjUuid: project.prjUuid,
    };

    if (Number(project.techGrade) === 1) {
      dataToSubmit.techGrade = 0;
      dataToSubmit.techStatus = '제안영업';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 2) {
      dataToSubmit.techGrade = 1;
      dataToSubmit.techStatus = '착수보고';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 3) {
      dataToSubmit.techGrade = 2;
      dataToSubmit.techStatus = '분석설계';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.techGrade) === 4) {
      dataToSubmit.techGrade = 3;
      dataToSubmit.techStatus = '구축(이행)';
      updateProjectStatus(dataToSubmit);
    }
  };

  return (
    <Box>
      <div ref={stepperRef}></div>

      <Stepper
        sx={{
          pt: 2,
          pb: 1,
          backgroundColor: '#eee',
        }}
        activeStep={activeStep}
        alternativeLabel
      >
        {steps.map((step) => {
          const stepProps = {};
          const labelProps = {};

          if (activeStep === steps.length - 1) {
            stepProps.completed = true;
          }
          return (
            <Step key={step.label} {...stepProps}>
              <StepLabel
                {...labelProps}
              // StepIconProps={{
              //   style: {
              //     color: '#424242'
              //   }
              // }}
              >{step.label}</StepLabel>
            </Step>
          )
        })}
      </Stepper>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}>
        <Box>
          {Number(activeStep) > 0 && (
            <Button variant="outlined" color={steps[Number(activeStep - 1)].color} onClick={handleBack} >
              {steps[activeStep - 1].label}
            </Button>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />

        {Number(activeStep) < steps.length - 1 && (
          <Button disabled={activeStep === steps.length - 1} variant="outlined" color={steps[Number(activeStep + 1)].color} onClick={handleNext}>
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>


      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <TechStepFirstContainer
          activeTap={activeTap}
          handleTabChange={handleTabChange}
        />
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}>


        <Box>
          {Number(activeStep) > 0 && (
            <Button variant="outlined" color={steps[Number(activeStep - 1)].color} onClick={handleBack} >
              {steps[activeStep - 1].label}
            </Button>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />

        {Number(activeStep) < steps.length - 1 && (
          <Button disabled={activeStep === steps.length - 1} variant="outlined" color={steps[Number(activeStep + 1)].color} onClick={handleNext}>
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      <AskDialog
        visible={visible}
        title="다음단계 이동"
        description="다음단계로 이동할 수 없습니다"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default TechStepperContainer;
